import { CptCodesTableRowModel } from "../../../../../data-model/cptCodesTableModel";
import { MedicalPaOrder } from "../../../../../data-model/medicalPaOrdersModel";
import { updateRowDataForDifferentKeys } from "./updateRowDataForDifferentKeys";

export const updateTableDataState = (
  rowIndex: number,
  fieldKey: string,
  fieldValue: any,
  singleMedicalPaOrder: MedicalPaOrder,
  originalTableData: CptCodesTableRowModel[],
  setTableData: React.Dispatch<React.SetStateAction<CptCodesTableRowModel[]>>,
  setHasChanges: React.Dispatch<React.SetStateAction<boolean>>,
  saveTableDataToLocalStorage: (data: CptCodesTableRowModel[]) => void,
): void => {
  setTableData((prevData: CptCodesTableRowModel[]) => {
    const updatedData = [...(prevData ?? [])];
    updatedData[rowIndex] = updateRowDataForDifferentKeys(
      fieldKey,
      updatedData[rowIndex],
      fieldValue,
      singleMedicalPaOrder ?? {},
    );

    const hasAnyChanges = checkForTableChanges(updatedData, originalTableData);
    setHasChanges(hasAnyChanges);
    saveTableDataToLocalStorage(updatedData);

    return updatedData;
  });
};

// Helper function to check if table data has changes compared to original
const checkForTableChanges = (
  updatedData: any[],
  originalTableData: CptCodesTableRowModel[],
): boolean => {
  return updatedData.some((row, index) => {
    const originalRow = originalTableData[index];
    if (!originalRow) return false;

    return Object.keys(row).some((key) => {
      return row[key] !== originalRow[key];
    });
  });
};
